import { useSelector } from 'react-redux';

import { TLocationSliceType } from '~/redux/slices/location/index';
import { routerPathsSelector } from '~/redux/slices/location/selectors';

export function useRouterPaths(): TLocationSliceType['routerPaths'] {
  return useSelector(routerPathsSelector);
}
